'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselCard", {
    enumerable: true,
    get: function() {
        return CarouselCard;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselCard = require("./useCarouselCard");
const _renderCarouselCard = require("./renderCarouselCard");
const _useCarouselCardStylesstyles = require("./useCarouselCardStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselCard = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselCard.useCarouselCard_unstable)(props, ref);
    (0, _useCarouselCardStylesstyles.useCarouselCardStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselCardStyles_unstable')(state);
    return (0, _renderCarouselCard.renderCarouselCard_unstable)(state);
});
CarouselCard.displayName = 'CarouselCard';
